export default "__VITE_ASSET__B0lCsxB0__"